import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';

import DocumentIcon from '@material-ui/icons/Archive';

const LinkToRelatedDocuments = ({ record, translate }) => (
      <Tooltip title="View attached documents">
        <Button 

            component={Link}
            to={{
                pathname: '/documents?filter={"client":"' + record.id + '"}' 
            }}
        >
           <DocumentIcon  />
        </Button>
      </Tooltip>
);

export default  LinkToRelatedDocuments ;
